/**
 * UserProfile 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const UserProfileProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'content.title',
        label: '제목',
        control: 'TextField',
        defaultValue: '회원 정보'
      }
    ]
  },
  {
    group: '회원정보 필드 설정',
    properties: [
      {
        name: 'basicFields.userId',
        label: '아이디 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.name',
        label: '이름 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.password',
        label: '비밀번호 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.phone',
        label: '전화번호 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.email',
        label: '이메일 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.birthday',
        label: '생년월일 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.createdAt',
        label: '가입일 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.address',
        label: '주소 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.referralLink',
        label: '추천링크 표시',
        control: 'Switch',
        defaultValue: true
      }
    ]
  },
  {
    group: '커스텀 필드',
    properties: [
      {
        name: 'varFields.var01.show',
        label: '커스텀 필드 1 표시',
        control: 'Switch',
        defaultValue: false
      },
      {
        name: 'varFields.var01.label',
        label: '커스텀 필드 1 이름',
        control: 'TextField',
        defaultValue: '필드 1',
        dependency: {
          name: 'varFields.var01.show',
          value: true
        }
      },
      {
        name: 'varFields.var02.show',
        label: '커스텀 필드 2 표시',
        control: 'Switch',
        defaultValue: false
      },
      {
        name: 'varFields.var02.label',
        label: '커스텀 필드 2 이름',
        control: 'TextField',
        defaultValue: '필드 2',
        dependency: {
          name: 'varFields.var02.show',
          value: true
        }
      },
      {
        name: 'varFields.var03.show',
        label: '커스텀 필드 3 표시',
        control: 'Switch',
        defaultValue: false
      },
      {
        name: 'varFields.var03.label',
        label: '커스텀 필드 3 이름',
        control: 'TextField',
        defaultValue: '필드 3',
        dependency: {
          name: 'varFields.var03.show',
          value: true
        }
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '8px'
      },
      {
        name: 'style.padding',
        label: '내부 여백',
        control: 'TextField',
        defaultValue: '20px'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'TextField',
        defaultValue: '0 2px 10px rgba(0, 0, 0, 0.1)'
      },
      {
        name: 'style.maxWidth',
        label: '최대 너비',
        control: 'TextField',
        defaultValue: '800px'
      }
    ]
  }
];

export default UserProfileProperties; 